import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=7112801e&scoped=true"
import script from "./MainSidebar.vue?vue&type=script&lang=js"
export * from "./MainSidebar.vue?vue&type=script&lang=js"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=7112801e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7112801e",
  null
  
)

export default component.exports